import aboutRoutingKeys from "Areas/About/routingKeys";
import api from "Common/api/api";
import { routesAndPagesMap } from "Common/routingUtils";
import { MenuItem, MenuItemWithModal } from "Components/menuGeneric";
import compact from "lodash/compact";
import React from "react";
import PasswordManager from "../passwordManager";
import UserInfo from "../userInfo";
import locale from "./buildProfileMenuItems.locale";
import { error } from "App/popupMessage";
import { store } from "App/redux";
import { removeCookieClientAuth } from "Common/cookies";
import { isAxiosError } from "axios";
import paths from "paths";
import styles from "./buildProfileMenuItems.module.css";
const handleLogout = async (event) => {
    var _a, _b;
    event.preventDefault();
    try {
        const response = await api.logoutApi();
        if (response.status === 200) {
            removeCookieClientAuth();
            window.location.href = paths.login;
        }
    }
    catch (AxiosError) {
        if (isAxiosError(AxiosError)) {
            const errorMessage = ((_b = (_a = AxiosError.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.message) || locale.LOGOUT_ERROR;
            store.dispatch(error(errorMessage, false));
        }
        else {
            store.dispatch(error(locale.LOGOUT_ERROR, false));
        }
    }
};
export default () => compact([
    React.createElement(MenuItem, { key: "0", content: React.createElement(UserInfo, null) }),
    React.createElement("li", { key: "1", className: "divider" }),
    React.createElement(MenuItemWithModal, { key: "2", text: locale.CHANGE_PASSWORD, title: locale.TITLE_PASSWORD, body: PasswordManager }),
    React.createElement(MenuItem, { key: "3", onClick: handleLogout, text: locale.EXIT, className: styles["red-color"] }),
    React.createElement("li", { key: "4", className: "divider" }),
    routesAndPagesMap.getPath(aboutRoutingKeys.ABOUT) && (React.createElement(MenuItem, { key: "5", href: routesAndPagesMap.getPath(aboutRoutingKeys.ABOUT) || "", text: locale.ABOUT }))
]);
